import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2413add6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OMensagemAcordeao" }
const _hoisted_2 = { class: "OMensagemAcordeao__MensagemBotao" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" este usuário não é responsável ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import Avatar from "primevue/avatar"
  import Button from "primevue/button"

  interface Props {
    icon: string
    responsabilidade: "projeto" | "recurso" | "profissional"
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OMensagemAcordeao',
  props: {
    icon: null,
    responsabilidade: null
  },
  setup(__props: any) {

const props = __props as {
    icon: string
    responsabilidade: "projeto" | "recurso" | "profissional"
  }

  
  let label: string

  const responsabilidadeEhProfissional = props.responsabilidade.slice(-1) === "l"

  if (responsabilidadeEhProfissional) {
    label = `adicionar ${props.responsabilidade.slice(0, -1)}is`
  } else {
    label = `adicionar ${props.responsabilidade}s`
  }

  const mensagem = `por nenhum ${props.responsabilidade}`

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Avatar), {
      class: "OMensagemAcordeao__Avatar",
      icon: __props.icon,
      shape: "circle"
    }, null, 8, ["icon"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createTextVNode(" " + _toDisplayString(mensagem) + " "),
      _createVNode(_unref(Button), {
        class: "OMensagemAcordeao__BotaoAdicionarResponsabilidade",
        label: _unref(label)
      }, null, 8, ["label"])
    ])
  ]))
}
}

})